"use strict";
exports.__esModule = true;
exports.arrowPath = void 0;
exports.arrowPath = "polygon(0 35%, 60% 35%, 60% 5%, 100% 50%, 60% 95%, 60% 65%, 0 65%);\n";
